import { render, staticRenderFns } from "./AssetGeneralTable.vue?vue&type=template&id=1f382cee"
import script from "./AssetGeneralTable.vue?vue&type=script&lang=js"
export * from "./AssetGeneralTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports